export var PracticeProfileUrlDeliveryMethod;
(function (PracticeProfileUrlDeliveryMethod) {
    PracticeProfileUrlDeliveryMethod["Link"] = "LINK";
    PracticeProfileUrlDeliveryMethod["Email"] = "EMAIL";
})(PracticeProfileUrlDeliveryMethod || (PracticeProfileUrlDeliveryMethod = {}));
